import axios, {AxiosError} from "axios";
import { API_URL } from "../constant";
import { AddFilingResult, ErrorResponse, FilingData } from "../constant";
import { getStringfromDate } from "../common";
  
export async function AddFiling(requestdata: FilingData): Promise<AddFilingResult> {
    try {
        const token = localStorage.getItem("token")
        
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
            validateStatus: (status: number) => {
                return status >= 200 && status < 500
            }
        };

        const modifiedData = {
            ...requestdata,
            transDate: getStringfromDate(requestdata.transDate),
            policyEffectiveDate: getStringfromDate(requestdata.policyEffectiveDate),
            transEffectiveDate: getStringfromDate(requestdata.transEffectiveDate),
        };
      
        const response = await axios.post(
          `${API_URL}api/filing/add`,
          modifiedData,
          config
        );
    
        if (response.status === 200)
        {
            return { success: true, newfiling: response.data };
        }
        else if (response.status === 400)
        {
            return { success: false, errorMsg: response.data.detail || "Validation Error" }; 
        }
        else if (response.status === 422)
        {
            return { success: false, errorMsg: "Validation Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}

export async function RemoveFiling(id: number): Promise<ErrorResponse> {

    try {
        const token = localStorage.getItem("token")
        
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
            validateStatus: (status: number) => {
                return status >= 200 && status < 500
            }
          };
      
        const requst = {
            id: id
        }
        const response = await axios.post(
          `${API_URL}api/filing/remove`,
          requst,
          config
        );
    
        if (response.status === 204)
        {
            return { success: true, errorMsg: "success to remove filing"};
        }
        else if (response.status === 400)
        {
            return { success: false, errorMsg: response.data.detail || "Validation Error" }; 
        }
        else if (response.status === 422)
        {
            return { success: false, errorMsg: "Validation Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}

export async function UpdateFiling(requestdata: FilingData): Promise<AddFilingResult> {
    try {
        const token = localStorage.getItem("token")
        
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
            validateStatus: (status: number) => {
                return status >= 200 && status < 500
            }
          };
      
        const modifiedData = {
            ...requestdata,
            transDate: getStringfromDate(requestdata.transDate),
            policyEffectiveDate: getStringfromDate(requestdata.policyEffectiveDate),
            transEffectiveDate: getStringfromDate(requestdata.transEffectiveDate),
        };
      
        const response = await axios.post(
          `${API_URL}api/filing/update`,
          modifiedData,
          config
        );
    
        if (response.status === 200)
        {
            return { success: true, newfiling: response.data };
        }
        else if (response.status === 400)
        {
            return { success: false, errorMsg: response.data.detail || "Validation Error" }; 
        }
        else if (response.status === 422)
        {
            return { success: false, errorMsg: "Validation Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}

export async function ReverseFiling(id: number, licenseNumber: string): Promise<ErrorResponse> {

    try {
        const token = localStorage.getItem("token")
        
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
            validateStatus: (status: number) => {
                return status >= 200 && status < 500
            }
          };
      
        const requst = {
            id: id,
            licenseNumber: licenseNumber
        }
        const response = await axios.post(
          `${API_URL}api/filing/reversal`,
          requst,
          config
        );
    
        if (response.status === 204)
        {
            // return { success: true, errorMsg: "A entry has been created and posted to offset the transaction you selected."};
            return { success: true, errorMsg: "Filing successfully reversed"};
        }
        else if (response.status === 422)
        {
            return { success: false, errorMsg: "Validation Error" };
        }
        else if (response.status === 400)
        {
            return { success: false, errorMsg: response.data.detail || "Validation Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}

export async function CheckFiling(requestdata: FilingData): Promise<AddFilingResult> {
    try {
        const token = localStorage.getItem("token")
        
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
            validateStatus: (status: number) => {
                return status >= 200 && status < 500
            }
        };
      
        const response = await axios.post(
          `${API_URL}api/upload/check`,
          requestdata,
          config
        );
    
        if (response.status === 200)
        {
            return { success: true, newfiling: response.data };
        }
        else if (response.status === 422)
        {
            return { success: false, errorMsg: "Validation Error" };
        }
        else if (response.status === 400)
        {
            return { success: false, errorMsg: response.data.detail || "Validation Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}

export async function AddFilings(requestdata: FilingData[]): Promise<ErrorResponse> {
    try {
        const token = localStorage.getItem("token")
        
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
            validateStatus: (status: number) => {
                return status >= 200 && status < 500
            }
        };
      
        const response = await axios.post(
          `${API_URL}api/upload/save`,
          requestdata,
          config
        );
    
        if (response.status === 204)
        {
            return { success: true, errorMsg: "Success to save filings" };
        }
        else if (response.status === 422)
        {
            return { success: false, errorMsg: "Validation Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}
